import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const FeePagination = ({
  currentPage = 1,
  pageSize = 20,
  totalItems = 0,
  onPageChange,
  onPageSizeChange
}) => {
  const totalPages = Math.max(1, Math.ceil(totalItems / pageSize));
  const startIndex = (currentPage - 1) * pageSize;
  const endIndex = Math.min(startIndex + pageSize, totalItems);

  if (totalItems === 0) return null;

  // Build page numbers window
  const getPageNumbers = () => {
    const pages = [];
    const maxVisible = 5;

    if (totalPages <= maxVisible) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      let start = Math.max(1, currentPage - 2);
      let end = Math.min(totalPages, start + maxVisible - 1);
      if (end - start < maxVisible - 1) {
        start = Math.max(1, end - maxVisible + 1);
      }
      for (let i = start; i <= end; i++) pages.push(i);
    }
    return pages;
  };

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: '10px',
        padding: '8px 4px 4px 4px',
        fontSize: '12px',
        color: '#64748b'
      }}
    >
      {/* Left: Range and Page Size */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
        <span>
          Showing <strong style={{ color: '#0f172a' }}>{startIndex + 1}–{endIndex}</strong> of{' '}
          <strong style={{ color: '#0f172a' }}>{totalItems}</strong> students
        </span>

        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
          <span style={{ fontSize: '11.5px' }}>Per page:</span>
          <select
            className="form-control"
            value={pageSize}
            onChange={(e) => onPageSizeChange(Number(e.target.value))}
            style={{
              height: '28px',
              fontSize: '11.5px',
              padding: '2px 6px',
              width: '64px',
              borderRadius: '4px',
              display: 'inline-block'
            }}
          >
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
          </select>
        </div>
      </div>

      {/* Right: Page Navigation */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
        <button
          type="button"
          className="btn btn-light"
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage <= 1}
          style={{
            height: '28px',
            padding: '0 8px',
            fontSize: '11.5px',
            borderRadius: '4px',
            border: '1px solid #cbd5e1',
            display: 'inline-flex',
            alignItems: 'center',
            gap: '2px',
            fontWeight: '600'
          }}
        >
          <ChevronLeft size={14} /> Prev
        </button>

        {getPageNumbers().map((pageNum) => (
          <button
            key={pageNum}
            type="button"
            className={`btn ${pageNum === currentPage ? 'btn-primary' : 'btn-light'}`}
            onClick={() => onPageChange(pageNum)}
            style={{
              height: '28px',
              minWidth: '28px',
              padding: '0 6px',
              fontSize: '11.5px',
              borderRadius: '4px',
              fontWeight: '700',
              border: pageNum === currentPage ? 'none' : '1px solid #cbd5e1'
            }}
          >
            {pageNum}
          </button>
        ))}

        <button
          type="button"
          className="btn btn-light"
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage >= totalPages}
          style={{
            height: '28px',
            padding: '0 8px',
            fontSize: '11.5px',
            borderRadius: '4px',
            border: '1px solid #cbd5e1',
            display: 'inline-flex',
            alignItems: 'center',
            gap: '2px',
            fontWeight: '600'
          }}
        >
          Next <ChevronRight size={14} />
        </button>
      </div>
    </div>
  );
};

export default FeePagination;
